import React, {Fragment} from 'react'
import {Router} from 'react-static'
import {hot} from 'react-hot-loader'
//
import Routes from 'react-static-routes'

import './app.css'
import {Navigation} from "./sections/Navigation";
import {CookieBanner} from "./sections/CookieBanner";

const App = () => (
    <Router>
        <Fragment>
            <Navigation/>
            <Routes/>
            <CookieBanner/>
        </Fragment>
    </Router>
)

export default hot(module)(App)



// WEBPACK FOOTER //
// /Users/stephan/skelware/savot/src/App.js